import {useState} from "react";

const downloadJSON = (value,name)=>{
  const blob=new Blob([JSON.stringify(value,null,2)],{type:"application/json;charset=utf-8"});
  const url=URL.createObjectURL(blob),link=document.createElement("a");
  link.href=url;link.download=name;document.body.appendChild(link);link.click();link.remove();
  setTimeout(()=>URL.revokeObjectURL(url),5000);
};
const shaFingerprint=async db=>{
  const fields={users:db.users,orders:db.orders,closings:db.closings||[],products:db.products,payments:db.payments||{}};
  const bytes=new TextEncoder().encode(JSON.stringify(fields));
  const hash=new Uint8Array(await crypto.subtle.digest("SHA-256",bytes));
  return btoa(String.fromCharCode(...hash));
};
export default function HistoricalImportManager({api}){
  const [manifest,setManifest]=useState(null),[preview,setPreview]=useState(null);
  const [backupFingerprint,setBackupFingerprint]=useState(""),[backupName,setBackupName]=useState("");
  const [backupSaved,setBackupSaved]=useState(false);
  const [confirmText,setConfirmText]=useState("");
  const [busy,setBusy]=useState(false),[notice,setNotice]=useState(""),[error,setError]=useState(""),[done,setDone]=useState(null);

  const chooseFile=async event=>{
    setManifest(null);setPreview(null);setError("");setNotice("");setDone(null);
    const file=event.target.files?.[0];if(!file)return;
    try{
      if(file.size>850000)throw new Error("Arquivo muito grande. Selecione o manifesto privado em JSON.");
      const parsed=JSON.parse(await file.text());
      if(parsed.schema!=="biogroup-historical-positions-v1"||parsed.position_count!==520||parsed.positions?.length!==520)
        throw new Error("Este não é o manifesto de 520 posições do BioGroup.");
      const auth=parsed.positions.filter(x=>x.import_authorization===true);
      if(auth.length!==312||new Set(auth.map(x=>x.source_id)).size!==312)
        throw new Error("A seleção não corresponde aos 312 IDs exclusivos autorizados.");
      setManifest(parsed);setNotice("Manifesto selecionado: 520 posições, 312 importações autorizadas.");
    }catch(e){setError(e.message||"Arquivo inválido.");}
  };
  const downloadBackup=async()=>{
    setBusy(true);setError("");setNotice("");setBackupFingerprint("");setBackupSaved(false);
    try{
      const {data}=await api.get("/admin/backup-export",{timeout:60000});
      if(data?.format!=="biogroup-db-backup-v1"||!data?.data?.users||!data?.data?.orders||!data?.fingerprint)
        throw new Error("O servidor não entregou uma cópia completa reconhecida.");
      const local=await shaFingerprint(data.data);
      if(local!==data.fingerprint)throw new Error("Falha de integridade: backup não corresponde ao fingerprint do servidor.");
      const name="BioGroup_BACKUP_PRIVADO_"+new Date().toISOString().slice(0,10)+".json";
      downloadJSON(data,name);
      setBackupName(name);setBackupFingerprint(data.fingerprint);
      setNotice("Backup exportado e conferido. Confira se o arquivo foi salvo antes de prosseguir.");
    }catch(e){setError(e.response?.data?.detail||e.message||"Erro ao exportar backup.");}
    finally{setBusy(false);}
  };
  const check=async()=>{
    if(!manifest)return;
    setBusy(true);setError("");setNotice("");setPreview(null);
    try{
      const {data}=await api.post("/admin/historical-import",{mode:"preview",manifest},{timeout:60000});
      setPreview(data);
      if(data.conflicts?.length)setError("Foram encontrados conflitos. Nada foi importado; corrija antes de confirmar.");
      else setNotice("Prévia validada no banco. Confira as quantidades abaixo.");
    }catch(e){setError(e.response?.data?.detail||"Não foi possível conferir a importação.");}
    finally{setBusy(false);}
  };
  const commit=async()=>{
    if(!backupFingerprint||!backupSaved||!preview?.ready||!manifest||confirmText!=="IMPORTAR")return;
    setBusy(true);setError("");setNotice("");
    try{
      const {data}=await api.post("/admin/historical-import",{
        mode:"commit",confirm:"IMPORTAR_312_POSICOES_52_BOXES",
        backup_fingerprint:backupFingerprint,manifest
      },{timeout:120000});
      if(data.mode!=="committed"&&data.mode!=="already_imported")throw new Error("Importação sem confirmação do servidor.");
      if(data.credentials?.length){
        downloadJSON({issued_at:new Date().toISOString(),credentials:data.credentials},
          "BioGroup_ACESSOS_INDIVIDUAIS_PRIVADO.json");
      }
      setDone(data);setNotice("Servidor confirmou a importação. Verifique a lista histórica e entregue os acessos individualmente.");
      setConfirmText("");
    }catch(e){setError(e.response?.data?.detail||e.message||"Falha ao importar. Verifique o estado antes de repetir.");}
    finally{setBusy(false);}
  };
  return <section className="table-section" style={{marginTop:24}}>
    <div className="section-head"><div>
      <p className="eyebrow">SOMENTE MASTER · MIGRAÇÃO HISTÓRICA</p>
      <h2>Importar a lista antiga do WhatsApp</h2>
      <p className="muted">A numeração dos BOXes e das posições originais não muda. Importação aditiva: não altera pedidos atuais, pagamentos ou estoque.</p>
    </div></div>
    <div className="bulk-products">
      <p><b>1. Baixe e guarde o backup integral</b></p>
      <button type="button" className="secondary" disabled={busy} onClick={downloadBackup}>Baixar backup privado e conferir integridade</button>
      {backupName&&<p className="muted">Arquivo: {backupName}</p>}
      <label><input type="checkbox" checked={backupSaved} disabled={!backupFingerprint} onChange={e=>setBackupSaved(e.target.checked)}/> Confirmo que o backup está salvo em local privado, fora do BioGroup.</label>
      <p><b>2. Selecione o manifesto privado final (JSON)</b></p>
      <label>Arquivo com 520 posições<input type="file" accept=".json,application/json" disabled={busy} onChange={chooseFile}/></label>
      <button type="button" className="secondary" disabled={busy||!manifest} onClick={check}>Conferir prévia sem importar</button>
      {preview&&<div className="price-editor-help">
        <b>Prévia do banco:</b> {preview.source?.positions} posições · {preview.source?.boxes} BOXes · {preview.source?.authorized} autorizadas.
        <div>{preview.new_positions} novas posições · {preview.already} existentes · {preview.new_accounts_needed} novas contas · {preview.linked_existing_positions} posições em contas existentes · {preview.unlinked_contact_positions} posições com contato pendente</div>
        {(preview.conflicts||[]).length>0&&<div>Conflitos: {preview.conflicts.map(x=>x.type).join(", ")}</div>}
      </div>}
      <p><b>3. Confirme somente após conferir a prévia e o backup</b></p>
      <label>Digite IMPORTAR para confirmar<input value={confirmText} disabled={busy} onChange={e=>setConfirmText(e.target.value.toUpperCase())} placeholder="IMPORTAR"/></label>
      <button className="primary" disabled={busy||!preview?.ready||!backupSaved||!backupFingerprint||confirmText!=="IMPORTAR"} onClick={commit}>
        {busy?"Processando…":"Importar 312 reservas com suas posições originais"}
      </button>
      {error&&<div className="error" role="alert"><span className="error-copy">{error}</span></div>}
      {notice&&<p className="settings-status" role="status">{notice}</p>}
      {done&&<div className="settings-status">Importação confirmada pelo servidor. Novas posições: {done.new_positions}; novas contas: {done.new_accounts}. Acesse BOXes históricos para conferir.</div>}
    </div>
  </section>;
}
